// www/src/themes/themes.js
// Single source of truth for theme metadata. The enum values match the Prisma Theme enum.
export const THEMES = [
  {
    key: 'SOFT_FLORAL',
    slug: 'soft-floral',
    label: 'Soft & Floral',
    fontsHref: 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;1,500&display=swap',
  },
  {
    key: 'WARM_EARTHY',
    slug: 'warm-earthy',
    label: 'Warm & Earthy',
    fontsHref: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600&family=Work+Sans:wght@400;500&display=swap',
  },
  {
    key: 'SPA_MODERN',
    slug: 'spa-modern',
    label: 'Clean & Spa-Modern',
    fontsHref: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500&display=swap',
  },
  {
    key: 'MOODY_LUXE',
    slug: 'moody-luxe',
    label: 'Moody & Luxe',
    fontsHref: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500&display=swap',
  },
];

export const DEFAULT_THEME = 'WARM_EARTHY';

export function findTheme(keyOrSlug) {
  if (!keyOrSlug) return null;
  const normalized = String(keyOrSlug).toUpperCase().replace(/-/g, '_');
  return THEMES.find((t) => t.key === normalized) || THEMES.find((t) => t.slug === keyOrSlug);
}
